import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SmartContractOperationService } from "../smart-contract-operation.service";
import { SmartContractViewService } from "../../smart-contract-view/smart-contract-view.service";
import { MatDialog } from "@angular/material/dialog";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";
import { ErrorDialogComponent } from "../../shared/dialogs/error-dialog.component";
import { KeycloakStateService } from "src/app/core/service/utility.service";
import { UnauthorizedDialogComponent } from "../../shared/dialogs/unauthorized-dialog/unauthorized-dialog.component";

@Component({
  selector: 'app-smart-contract-operation-submit',
  templateUrl: './smart-contract-operation-submit.component.html',
  styleUrls: ['./smart-contract-operation-submit.component.scss']
})
export class SmartContractOperationSubmitComponent implements OnInit {

  form!: FormGroup;

  chaincodeId!: string;
  channel!: string;
  chaincode!: string;

  loading: boolean = false;
  keys: string[] = [];

  constructor(
    private service: SmartContractOperationService,
    private viewService: SmartContractViewService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private keycloakState: KeycloakStateService
  ) { }

  roles: string[] = [];

  canAccessOperation(): boolean {
    return this.roles.includes('smart_contract_operator')
  }

  ngOnInit(): void {
    
    this.keycloakState.observeRealmRoles().subscribe((roles) => {
      this.roles = roles || [];

      //  Role check
      // if (!this.canAccessOperation()) {
      //   this.openUnauthorizedDialog();
      //   this.router.navigate(['/secure-blockchain/auth-tools/operation/search']);
      //   return;
      // }

      //  Only load if authorized
      this.chaincodeId = this.route.snapshot.paramMap.get('id')!;

      this.form = new FormGroup({
        mode: new FormControl('existing', Validators.required),
        key: new FormControl(null, Validators.required),
        content: new FormControl(null, Validators.required)
      });

      this.form.get('mode')?.valueChanges.subscribe(() => {
        this.form.patchValue({ key: null });

        this.form.get('key')?.setValue(null);
        this.form.get('key')?.markAsUntouched();
        this.form.get('key')?.updateValueAndValidity();
      });

      this.loadChaincodeDetails();
    });
  }

  loadKeys(): void {
    if (!this.channel || !this.chaincode) return;

    this.viewService.getKeys(this.channel, this.chaincode)
      .subscribe((res: any[]) => {
        this.keys = res || [];

        if (this.keys.length === 0) {
          this.form.patchValue({ mode: 'new' });
        }
      });
  }

  loadChaincodeDetails(): void {
    this.service.getContractById(this.chaincodeId)
      .subscribe((data: any) => {

        if (!data) {
          alert("Chaincode not found");
          this.cancel();
          return;
        }

        this.channel = data.channelName;
        this.chaincode = data.chaincodeName;

        this.loadKeys();
      });
  }

  onKeySelect(event: any): void {
    const selectedKey = event.target.value;

    if (selectedKey) {
      this.form.patchValue({ key: selectedKey });

      // OPTIONAL: load existing content
      // this.viewService.getValueByKey(this.channel, this.chaincode, selectedKey)
      //   .subscribe(res => {
      //     this.form.patchValue({ content: res });
      //   });
    }
  }

  submit(): void {

    if (this.form.invalid) return;

    const { mode, key, content } = this.form.value;

    // Extra safety validation
    if (mode === 'existing' && !key) {
      this.openErrorDialog('Please select an existing key');
      return;
    }

    if (mode === 'new' && !key) {
      this.openErrorDialog('Please enter a new key');
      return;
    }

    const payload = {
      channel: this.channel,
      chaincode: this.chaincode,
      contract: "SmartContract",
      id: key,
      content: content
    };

    this.loading = true;

    this.service.submitTransaction(payload)
      .subscribe({
        next: () => {
          this.loading = false;
          this.router.navigate(['/secure-blockchain/auth-tools/operation/search']);
        },
        error: () => {
          this.loading = false;
          this.openErrorDialog('Transaction failed');
        }
      });
  }

  cancel(): void {
    this.router.navigate(['/secure-blockchain/auth-tools/operation/search']);
  }

  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: { isCreate: true, title: "Transaction" },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/secure-blockchain/auth-tools/operation/search']);
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/secure-blockchain/auth-tools/operation/search']);
    });
  }

  openUnauthorizedDialog(): void {
    const dialogRef = this.dialog.open(UnauthorizedDialogComponent, {
      width: "300px"
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/secure-blockchain/auth-tools/operation/search']);
    });
  }

}